import { IPlayersOnlineRepository } from '@base/features/player/model/interfaces';
import { ITable, IGameService } from '@base/features/game/model/interfaces';
import { t } from '@base/utils/helpers';
import { container } from 'tsyringe';
import GameMenuButtons, { MenuButton } from './gameMenuButtons';
import Codes from '@base/features/socket/codes';

export default function Resign(props: { closeModal: () => void }) {
  const playersOnlineRepository: IPlayersOnlineRepository = container.resolve('playersOnlineRepository');
  const gameService: IGameService = container.resolve('gameService');
  const table = playersOnlineRepository.me?.getTable();

  return table ? (
    table.maxPoints !== 1 ? (
      <ResignLongGame
        playersOnlineRepository={playersOnlineRepository}
        gameService={gameService}
        closeModal={props.closeModal}
        table={table}
      />
    ) : (
      <ResignShortGame
        playersOnlineRepository={playersOnlineRepository}
        gameService={gameService}
        closeModal={props.closeModal}
        table={table}
      />
    )
  ) : null;
}

const ResignShortGame = (props: {
  playersOnlineRepository: IPlayersOnlineRepository;
  gameService: IGameService;
  table: ITable;
  closeModal: () => void;
}) => {
  const handleResign = () => {
    props.gameService.sendPlay(
      Codes.PlayCommand.RESIGN,
      props.playersOnlineRepository.me?.getPid(),
      props.table.tid
    );
    props.closeModal();
  };

  const buttons: MenuButton[] = [
    {
      title: t('yes'),
      onClick: () => handleResign(),
    },
    {
      title: t('cancel'),
      onClick: () => props.closeModal(),
    },
  ];

  return (
    <>
      <p>{t('sure_want_to_resign')}</p>
      <GameMenuButtons buttons={buttons} />
    </>
  );
};

const ResignLongGame = (props: {
  playersOnlineRepository: IPlayersOnlineRepository;
  gameService: IGameService;
  table: ITable;
  closeModal: () => void;
}) => {
  const handleLooseMatch = () => {
    props.gameService.sendPlay(
      Codes.PlayCommand.RESIGN,
      props.playersOnlineRepository?.me?.getPid(),
      props.table.tid
    );
    props.closeModal();
  };

  const handleResign = (code: any) => {
    props.gameService.sendPlay(code, props.playersOnlineRepository.me?.getPid(), props.table.tid);
    props.table?.getGameState()?.setStatusMessage(t('waiting_for_opponent_confirmation'));
    props.closeModal();
  };

  const buttons = [
    {
      title: t('the_whole_match'),
      onClick: () => handleLooseMatch(),
    },
    {
      title: t('lose_current_number_points'),
      onClick: () => handleResign(Codes.PlayCommand.RESIGN_CUR),
    },
    {
      title: t('lose_doubled_number_points'),
      onClick: () => handleResign(Codes.PlayCommand.RESIGN_DBL),
    },
    {
      title: t('cancel'),
      onClick: () => props.closeModal(),
    },
  ];

  return (
    <>
      <p>{t('sure_want_to_resign')}</p>
      <GameMenuButtons buttons={buttons} />
    </>
  );
};
